import React from 'react'
import { connect } from 'react-redux';
import { Button } from 'antd';
import { openDrawer } from '../actions/Drawer';
import BusSignsDepartures from './BusSignsDepartures';

class BusSignsDeparturesButton extends React.Component {
    render() {
        return (
            <Button
                type="link"
                onClick={(e) => {
                    e.preventDefault();
                    this.props.openDrawer(
                        'Odjezdy pro ' + this.props.serialNumber,
                        <BusSignsDepartures serialNumber={this.props.serialNumber} />,
                        1000
                    );
                }}
            >
                Odjezdy
            </Button>
        );
    }
}

export default connect(
    null,
    { openDrawer }
)(BusSignsDeparturesButton)
